import { Flex, useColorMode } from '@chakra-ui/core';
import React from 'react';

import BackupTracks from './BackupTracks';
import PlaybackQueue from './PlaybackQueue';

const QueuePanel = () => {
    const { colorMode } = useColorMode();
    const color = { light: 'gray.900', dark: 'gray.100' };

    return (
        <Flex overflow="auto" mr="-15px" flex={1} position="relative" direction="column" color={color[colorMode]}>
            <PlaybackQueue />
            <BackupTracks />
        </Flex>
    );
};

export default QueuePanel;
